module.exports = __webpack_public_path__ + "static/media/logoCigna.ac222736.png";